<template>
  <div id="MembershipCard_PrintTemplate">
    <section class="logo-area">
      <img src="@/assets/img/print/LOGONAME.png" class="logo"/>

      <div class="logo-title">會員資料</div>
    </section>

    <section class="info-area">
      <table cellspacing="0">
        <tr>
          <td width="3%" rowspan="0" class="text-vertical" valign="center" align="center" bgcolor="#93d2fe">繳款人</td>

          <td colspan="5" align="center" bgcolor="#93d2fe">要助人（繳費人）</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">姓名</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">性別</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">出生日期</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">身分證</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">電話</td>
        </tr>

        <tr>
          <td align="center">{{ data.pay_name }}</td>
          <td align="center">{{ getGender(data.pay_ID_number) }}</td>
          <td align="center">{{ convertRocDate(data.pay_birthday) }}</td>
          <td align="center">{{ data.pay_ID_number }}</td>
          <td align="left" class="text-small">手機：{{ data.pay_cellphone }}</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">戶籍地址</td>
          <td align="left" colspan="3" class="text-small">{{ data.pay_HpostalCode }}{{ data.pay_HpostalCode }}</td>
          <td align="left" class="text-small">市話：{{ data.pay_phone }}</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">通訊地址</td>
          <td align="left" colspan="3" class="text-small">{{ data.pay_CpostalCode }}{{ data.pay_Caddress }}</td>
          <td align="left" class="text-small">公司：</td>
        </tr>
      </table>
    </section>

    <section class="info-area">
      <table cellspacing="0">
        <tr>
          <td width="3%" rowspan="0" class="text-vertical" valign="center" align="center" bgcolor="#93d2fe">互助人</td>

          <td colspan="5" align="center" bgcolor="#93d2fe">互助人（會員）</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">姓名</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">性別</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">出生日期</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">身分證</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">與要助人之關係</td>
        </tr>

        <tr>
          <td align="center">{{ data.member_name }}</td>
          <td align="center">{{ getGender(data.member_ID_number) }}</td>
          <td align="center">{{ convertRocDate(data.member_birthday) }}</td>
          <td align="center">{{ data.member_ID_number }}</td>
          <td align="center">{{ data.member_relation }}</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">戶籍地址</td>
          <td align="left" colspan="4"></td>
        </tr>
      </table>
    </section>

    <section class="info-area">
      <table cellspacing="0">
        <tr>
          <td width="3%" rowspan="0" class="text-vertical" valign="center" align="center" bgcolor="#93d2fe">受款人</td>

          <td colspan="5" align="center" bgcolor="#93d2fe">互助金受款人</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">姓名</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">性別</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">出生日期</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">身分證</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">與互助人之關係</td>
        </tr>

        <tr>
          <td align="center">{{ data.beneficiary_name }}</td>
          <td align="center">{{ getGender(data.beneficiary_ID_number) }}</td>
          <td align="center">{{ convertRocDate(data.beneficiary_birthday) }}</td>
          <td align="center">{{ data.beneficiary_ID_number }}</td>
          <td align="center">{{ data.beneficiary_relation }}</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">手機</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">住家電話</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">公司電話</td>
          <td rowspan="0" colspan="2" valign="center" align="center"></td>
        </tr>

        <tr>
          <td align="center">{{ data.beneficiary_cellphone }}</td>
          <td align="center">{{ data.beneficiary_phone }}</td>
          <td align="center"></td>
        </tr>
      </table>
    </section>

    <section class="info-area">
      <table cellspacing="0" :class="{ 'policy-extra-table': policyRule.hasExtraGuarantee }">
        <tr>
          <td width="3%" rowspan="0" class="text-vertical" valign="center" align="center" bgcolor="#93d2fe">{{ data.plan === 'A' ? '永保' : '長安' }}專案</td>

          <td :width="policyRule.hasExtraGuarantee ? '32%' : '45%'" align="center" bgcolor="#c6c4c4" class="text-weight-bold">{{ policyRule.periodTitle }}</td>

          <td
            :width="policyRule.hasExtraGuarantee ? '65%' : '52%'"
            :colspan="policyRule.hasExtraGuarantee ? 2 : 1"
            align="center"
            bgcolor="#c6c4c4"
            class="text-weight-bold"
          >{{ policyRule.guaranteeTitle }}</td>
        </tr>

        <tr v-for="(item, index) in policyRule.rule" :key="index">
          <td align="center" v-html="item.period.replace(/<br\s*\/?>/g, '<br>')"></td>
          <td
            :colspan="policyRule.hasExtraGuarantee && !item.extraGuarantee ? 2 : 1"
            align="center"
            v-html="item.guarantee.replace(/<br\s*\/?>/g, '<br>')"
          ></td>
          <td v-if="policyRule.hasExtraGuarantee && item.extraGuarantee" align="center" class="policy-extra" v-html="item.extraGuarantee.replace(/<br\s*\/?>/g, '<br>')"></td>
        </tr>
      </table>
    </section>

    <section class="info-area">
      <table cellspacing="0">
        <tr>
          <td width="3%" rowspan="0" valign="center" align="center" bgcolor="#93d2fe">業務代表</td>

          <td width="41%" colspan="2" align="center" bgcolor="#c6c4c4" class="text-weight-bold">業務代表</td>

          <td width="41%" align="center" bgcolor="#c6c4c4" class="text-weight-bold">專案名稱</td>

          <td width="15%" rowspan="0" valign="center" align="center"></td>
        </tr>

        <tr>
          <td colspan="2" align="center">{{ data.sales_number }}{{ data.sales_name }}</td>
          <td align="center">{{ data.plan === 'A' ? '永保' : '長安' }}專案</td>
        </tr>

        <tr>
          <td colspan="2" align="center" bgcolor="#c6c4c4" class="text-weight-bold">生效日期</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">互助契約單號</td>
        </tr>

        <tr>
          <td colspan="2" align="center">{{ convertRocDate(data.join_date) }}</td>
          <td align="center">{{ data.number }}</td>
        </tr>

        <tr>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">收件</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">建檔</td>
          <td align="center" bgcolor="#c6c4c4" class="text-weight-bold">審核</td>
        </tr>

        <tr class="long">
          <td align="center"></td>
          <td align="center"></td>
          <td align="center"></td>
        </tr>
      </table>
    </section>

    <div class="bar-code">
      <img id="barCode_number" />

      <span>{{ this.data.number }}</span>
    </div>

     <!-- <section class="payer-area">
      <table cellspacing="0">
        <tr bgcolor="#93d2fe" >
          <td width="3%" rowspan="0" class="text-vertical" valign="center" align="center">繳<br/>款<br/>人</td>

          <td colspan="5" align="center">要助人（繳費人）</td>
        </tr>

        <tr bgcolor="#c6c4c4">
          <td align="center">姓名</td>
          <td align="center">性別</td>
          <td align="center">出生日期</td>
          <td align="center">身分證</td>
          <td align="center">電話</td>
        </tr>

        <tr>
          <td align="center"></td>
          <td align="center"></td>
          <td align="center"></td>
          <td align="center"></td>
          <td align="center"></td>
        </tr>

        <tr>
          <td align="center"></td>
          <td align="center" colspan="3"></td>
          <td align="center"></td>
        </tr>

        <tr>
          <td align="center"></td>
          <td align="center" colspan="3"></td>
          <td align="center"></td>
        </tr>

      </table>
    </section> -->
  </div>
</template>

<script>
import jsbarcode from 'jsbarcode';
import { convertRocDate, getGender } from "@/models/HELPERS/common.js";

export default {
  name: 'MembershipCard',
  props: {
    width: {
      type: String,
      required: false,
      default: '100%'
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  watch: {
    'data.id': {
      handler(newValue, oldValue) {
        this.$nextTick(() => {
          this.generateBarcode();
        });
      },
      immediate: false
    }
  },
  data () {
    return {
      policy: [
        {
          plan: 'A',
          start: '2016-01-01',
          end: '2018-01-14',
          periodTitle: '繳費互助期間',
          guaranteeTitle: '20萬互助金保障',
          rule: [
            {
              period: '生效日～30日',
              guarantee: '退回入會費2000元'
            },
            {
              period: '31日～6個月',
              guarantee: '總繳互助費＋2000元'
            },
            {
              period: '6個月～12個月',
              guarantee: '總繳互助費＋6000元'
            },
            {
              period: '12個月～18個月',
              guarantee: '總繳互助費＋12000元'
            },
            {
              period: '18個月～24個月',
              guarantee: '總繳互助費＋18000元'
            },
            {
              period: '25個月以上～滿額前',
              guarantee: '20萬'
            },
            {
              period: '滿額終身保障(免繳互助費)',
              guarantee: '20萬＋30000元'
            }
          ]
        },
        {
          plan: 'B',
          start: '2016-01-01',
          end: '2018-01-14',
          periodTitle: '繳費互助期間',
          guaranteeTitle: '40萬互助金保障',
          rule: [
            {
              period: '生效日～30日',
              guarantee: '退回入會費2000元'
            },
            {
              period: '31日～6個月',
              guarantee: '總繳互助費＋5000元'
            },
            {
              period: '6個月～12個月',
              guarantee: '總繳互助費＋12000元'
            },
            {
              period: '12個月～18個月',
              guarantee: '總繳互助費＋26000元'
            },
            {
              period: '18個月～24個月',
              guarantee: '總繳互助費＋32000元'
            },
            {
              period: '24個月～30個月',
              guarantee: '總繳互助費＋42000元'
            },
            {
              period: '30個月～36個月',
              guarantee: '總繳互助費＋62000元'
            },
            {
              period: '37個月以上～滿額前',
              guarantee: '40萬'
            },
            {
              period: '滿額終身保障(免繳互助費)',
              guarantee: '40萬＋60000元'
            }
          ]
        },
        {
          plan: 'A',
          start: '2018-01-15',
          end: '2020-12-31',
          periodTitle: '繳費互助期間',
          guaranteeTitle: '20萬互助金保障',
          rule: [
            {
              period: '生效日～30日',
              guarantee: '退回入會費2000元'
            },
            {
              period: '31日～90日',
              guarantee: '總繳互助費＋2000元'
            },
            {
              period: '91日～36個月',
              guarantee: '總繳互助費30%慰問金'
            },
            {
              period: '37個月以上～滿額前',
              guarantee: '20萬(未使用生命禮儀折算18萬或領回總繳互助費)'
            },
            {
              period: '滿額終身保障(免繳互助費)',
              guarantee: '20萬＋20000元'
            }
          ]
        },
        {
          plan: 'B',
          start: '2018-01-15',
          end: '2020-12-31',
          periodTitle: '繳費互助期間',
          guaranteeTitle: '30萬互助金保障',
          rule: [
            {
              period: '生效日～30日',
              guarantee: '退回入會費2000元'
            },
            {
              period: '31日～90日',
              guarantee: '總繳互助費＋2000元'
            },
            {
              period: '91日～36個月',
              guarantee: '總繳互助費30%慰問金'
            },
            {
              period: '37個月以上～滿額前',
              guarantee: '30萬(未使用生命禮儀折算27萬或領回總繳互助費)'
            },
            {
              period: '滿額終身保障(免繳互助費)',
              guarantee: '30萬＋30000元'
            }
          ]
        },
        {
          plan: 'A',
          start: '2021-01-01',
          end: '2022-12-31',
          periodTitle: '繳費互助期間',
          guaranteeTitle: '20萬互助金保障',
          rule: [
            {
              period: '生效日～30日',
              guarantee: '退回入會費2000元'
            },
            {
              period: '31日～90日',
              guarantee: '總繳互助費＋2000元'
            },
             {
              period: '91日～12個月',
              guarantee: '總繳互助費＋3000元'
            },
            {
              period: '第13個月～36個月',
              guarantee: '總繳互助費＋18%'
            },
            {
              period: '37個月以上～滿額前',
              guarantee: '20萬(未使用生命禮儀折算17萬或領回總繳互助費)'
            },
            {
              period: '滿額終身保障(免繳互助費)',
              guarantee: '20萬＋20000元'
            }
          ]
        },
        {
          plan: 'B',
          start: '2021-01-01',
          end: '2022-12-31',
          periodTitle: '繳費互助期間',
          guaranteeTitle: '30萬互助金保障',
          rule: [
            {
              period: '生效日～30日',
              guarantee: '退回入會費2000元'
            },
            {
              period: '31日～90日',
              guarantee: '總繳互助費＋2000元'
            },
             {
              period: '91日～12個月',
              guarantee: '總繳互助費＋5000元'
            },
            {
              period: '第13個月～36個月',
              guarantee: '總繳互助費＋18%'
            },
            {
              period: '37個月以上～滿額前',
              guarantee: '30萬(未使用生命禮儀折算26萬或領回總繳互助費)'
            },
            {
              period: '滿額終身保障(免繳互助費)',
              guarantee: '30萬＋30000元'
            }
          ]
        },
        {
          plan: 'A',
          start: '2023-01-01',
          end: '2023-12-31',
          periodTitle: '繳費互助期間',
          guaranteeTitle: '20萬互助金保障',
          rule: [
            {
              period: '生效日～30日',
              guarantee: '退回入會費2000元'
            },
            {
              period: '31日～未滿36個月',
              guarantee: '退還總繳互助費X113%'
            },
            {
              period: '第37個月起～滿額前',
              guarantee: '20萬(未使用生命禮儀折算17萬或領回總繳互助費)'
            },
            {
              period: '滿額後終身保障<br />(免繳任何費用)<br />(滿額祝壽金)',
              guarantee: '20萬＋每年祝壽金2000元<br />(繳費滿額當月之隔年開始,每周年當月領取祝壽金)'
            }
          ]
        },
        {
          plan: 'B',
          start: '2023-01-01',
          end: '2023-12-31',
          periodTitle: '繳費互助期間',
          guaranteeTitle: '30萬互助金保障',
          rule: [
            {
              period: '生效日～30日',
              guarantee: '退回入會費2000元'
            },
            {
              period: '31日～未滿36個月',
              guarantee: '退還總繳互助費X113%'
            },
            {
              period: '第37個月起～滿額前',
              guarantee: '30萬(未使用生命禮儀折算26萬或領回總繳互助費)'
            },
            {
              period: '滿額後終身保障<br />(免繳任何費用)<br />(滿額祝壽金)',
              guarantee: '30萬＋每年祝壽金3000元<br />(繳費滿額當月之隔年開始,每周年當月領取祝壽金)'
            }
          ]
        },
        {
          plan: 'A',
          start: '2024-01-01',
          end: new Date(),
          hasExtraGuarantee: true,
          periodTitle: '繳費互助期間',
          guaranteeTitle: '30萬互助金保障',
          rule: [
            {
              period: '未滿36個月',
              guarantee: '退還總繳互助費X113%<br />(未滿30日身故,退回入會費)',
              extraGuarantee: '禮儀加給（補助金）<br />圓滿型:2萬/宜禮型:1.5萬'
            },
            {
              period: '第37個月起～繳滿30萬前身故',
              guarantee: '27萬元(或總繳互助費,擇高給付)<br />或<br />30萬元(須使用生命禮儀,已含禮儀補助金)'
            },
            {
              period: '30萬繳滿後身故',
              guarantee: '30萬元',
              extraGuarantee: '禮儀加給（補助金）<br />圓滿型:2萬/宜禮型:1.5萬'
            },
            {
              period: '滿額祝壽金',
              guarantee: '繳費滿額當月之隔年開始<br />每周年當月領取祝壽金3000元'
            }
          ]
        },
        {
          plan: 'B',
          start: '2024-01-01',
          end: new Date(),
          periodTitle: '繳費互助期間',
          guaranteeTitle: '30萬互助金保障(年金型)',
          rule: [
            {
              period: '未滿42個月身故',
              guarantee: '退還總繳互助費X113%<br />(未滿30日身故,退回入會費)'
            },
            {
              period: '第43個月~繳滿後身故',
              guarantee: '30萬元'
            },
            {
              period: '滿60個月後祝壽金',
              guarantee: '每年祝壽金5000元<br />繳費滿60個月當月之隔年開始<br />每周年當月領取祝壽金'
            }
          ]
        },
      ]
    }
  },
  computed: {
    policyRule() {
      return this.policy.find(item => {
        const join_date = new Date(this.data.join_date);
        const start = new Date(item.start);
        const end = new Date(item.end);

        return join_date >= start && join_date <= end && this.data.plan === item.plan;
      })
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {
      this.$nextTick(() => {
        this.generateBarcode();
      });
    },
    convertRocDate,
    getGender,
    generateBarcode() {
      jsbarcode(`#barCode_number`, this.data.number, {
        forat: "CODE39",
        margimnBottom: 5,
        font: "DFKai-sb",
        displayValue: false
      });
    }
  }
}
</script>

<style lang="scss" scoped>
* {
  font-family: DFKai-sb;
}

#MembershipCard_PrintTemplate {
  width: 794px;
  height: 1123px;
  .logo-area {
    display: grid;
    grid-template-columns: 1fr 1fr;
    row-gap: 5px;
    margin-bottom: 30px;
    .logo {
      height: 90px;
      width: 380px;
    }
    .logo-title {
      font-size: 26px;
      font-weight: bold;
      margin: auto 0 0 40px;
    }
  }
  .info-area {
    &:not(:last-child) {
      margin-bottom: 25px;
    }
    table {
      width: 100%;
      table-layout: fixed;
      word-wrap: break-word;
      word-break: normal;
      font-size: 18px;
      line-height: 1;
      border: 1px solid #000000;
      tr {
        height: 25px;
        &.long {
          height: 50px;
        }
        td {
          border: 1px solid #000000;
          &.text-weight-bold {
            font-weight: bold;
          }
          &.text-small {
            font-size: 16px;
          }
          &.policy-extra {
            font-size: 14px;
            line-height: 1.2;
          }
        }
      }
      &.policy-extra-table {
        font-size: 16px;
      }
    }
  }
  .bar-code {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    width: 200px;
    height: auto;
    img {
      width: 100%;
      height: 35px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/common/PrintTemplate/MembershipCard.vue